//财务模块接口设置
import {
  postRequest,
  postRequestParams,
  getRequest,
  fileUpload,
  postDataParams,
} from "@/api/request"; // 导入request中创建的axios实例
const finance = {
  borrow: {
    //借款模块
    update: (mode, params) => {
      //app新增借款接口-陈国贵|app编辑借款接口-陈国贵
      return mode == "add" ?
        postRequest("/app/borrow/add", params) //app新增借款接口-陈国贵
        :
        postRequest("/app/borrow/edit", params); //app编辑借款接口-陈国贵
    },
    detail: (id) => {
      //app根据id查询借款详情接口-陈国贵
      return getRequest("/app/borrow/get/" + id, {});
    },
    deleteRecall: (mode, id) => {
      //app根据id删除接口-陈国贵|app撤回流程接口-陈国贵
      return mode == "hold" ?
        getRequest("app/borrow/delete/" + id, {}) //app根据id删除接口-陈国贵
        :
        getRequest("app/borrow/recall/" + id, {}); //app撤回流程接口-陈国贵
    },
  },
  reimburse: {
    //报销申请接口
    update: (mode, params) => {
      //app新增报销申请接口-陈国贵|app编辑报销申请接口-陈国贵
      return mode == "add" ?
        postRequest("app/reimburse/add", params) //app新增报销申请接口-陈国贵
        :
        postRequest("app/reimburse/edit", params); //app编辑报销申请接口-陈国贵
    },
    detail: (id) => {
      //app根据报销id查询报销信息接口-陈国贵
      return getRequest("/app/reimburse/get/" + id, {});
    },
    deleteRecall: (mode, id) => {
      //app根据报销id删除报销信息
      return mode == "hold" ?
        getRequest("app/reimburse/delete/" + id, {}) :
        getRequest("app/reimburse/recall/" + id, {});
    },

    incomeAndExpenses: params => {
      //app项目管理-收支统计-收支情况接口-陈国贵
      return getRequest("app/project/info/incomeAndExpenses", params);
    },
    reimburseIncomeAndExpenses: params => {
      //app项目管理-收支统计-收支情况接口-陈国贵
      return getRequest("app/project/info/reimburseIncomeAndExpenses", params);
    },
    getCostInfo: params => {
      //app根据项目id获取报销成本费用信息-陈国贵
      return getRequest("app/reimburse/getCostInfo", params);
    },
  },
  transfer: {
    //移交申请相关接口
    getProjectList: (pageNum, pageSize, param) => {
      //app报销移交选择项目列表-分页-陈国贵
      return postRequest("app/reimburse/transfer/projectList/" + pageNum + '/' + pageSize, param);
    },
    update: (mode, params) => {
      //app保证金申请接口-陈国贵|app编辑保证金接口-陈国贵
      return mode == "add" ?
        postRequest("app/reimburse/transfer/add", params) //app新增报销移交申请接口-陈国贵
        :
        postRequest("app/reimburse/transfer/edit", params); //app编辑报销移交申请接口-陈国贵
    },
    detail: (id) => {
      //app根据报销移交申请id查询信息-陈国贵
      return getRequest("app/reimburse/transfer/get/" + id, {});
    },
    deleteTransfer: (mode, id) => {
      //app根据id删除保证金信息接口-陈国贵
      return mode == "hold" ?
        getRequest("app/reimburse/transfer/delete/" + id, {}) //app根据报销移交id删除信息-陈国贵
        :
        getRequest("app/reimburse/transfer/recall/" + id, {}); //app流程撤回接口-陈国贵
    },
    getReimbureList: (pageNum, pageSize, param) => {//app报销列表接口-分页-陈国贵
      return postRequest("app/reimburse/transfer/reimburseList/" + pageNum + '/' + pageSize, param);
    },
  },

  margin: {
    //保证金模块相关接口
    update: (mode, params) => {
      //app保证金申请接口-陈国贵|app编辑保证金接口-陈国贵
      return mode == "add" ?
        postRequest("app/margin/add", params) //app保证金申请接口-陈国贵
        :
        postRequest("app/margin/edit", params); //app编辑保证金接口-陈国贵
    },
    detail: (id) => {
      //app根据id查询保证金信息-陈国贵
      return getRequest("app/margin/get/" + id, {});
    },
    deleteRecall: (mode, id) => {
      //app根据id删除保证金信息接口-陈国贵
      return mode == "hold" ?
        getRequest("app/margin/delete/" + id, {}) //app根据id删除保证金信息接口-陈国贵
        :
        getRequest("app/margin/recall/" + id, {}); //app流程撤回接口-陈国贵
    },

    myProject: (pageNum,pageSize,params) => { //App项目经理负责的项目-陈国贵
      return postRequest("app/project/info/manageProjectList/"+pageNum+'/'+pageSize, params);
    },
  },
  funding: {
    //用户资金申请相关接口
    update: (mode, params) => {
      //app端新增资金申请接口-陈国贵|app端编辑资金申请接口-陈国贵
      return mode == "add" ?
        postRequest("app/funding/add", params) //app端新增资金申请接口-陈国贵
        :
        postRequest("app/funding/edit", params); //app端编辑资金申请接口-陈国贵
    },
    detail: (id) => {
      //app端根据id查询资金申请信息-陈国贵
      return getRequest("app/funding/get/" + id, {});
    },
    deleteRecall: (mode, id) => {
      //app端根据id删除用户资金申请-陈国贵|app端流程撤回接口-陈国贵
      return mode == "hold" ?
        getRequest("app/funding/delete/" + id, {}) //app端根据id删除用户资金申请-陈国贵
        :
        getRequest("app/funding/recall/" + id, {}); //app端流程撤回接口-陈国贵
    },
  },
  applyOthers: {
    //用户其他申请管理
    update: (mode, params) => {
      //新增用户其他申请接口-肖东|编辑用户其他申请接口-肖东
      return mode == "add" ?
        postRequest("app/applyOthers/add", params) //新增用户其他申请接口-肖东
        :
        postRequest("app/applyOthers/update", params); //编辑用户其他申请接口-肖东
    },
    detail: (id) => {
      //用户其他申请详情接口-肖东
      return getRequest("app/applyOthers/details/" + id, {});
    },
    deleteRecall: (mode, id) => {
      //删除用户其他申请接口-肖东|撤回用户其他申请接口-肖东
      return mode == "hold" ?
        postRequest("app/applyOthers/deleted/" + id, {}) //删除用户其他申请接口-肖东
        :
        postRequest("app/applyOthers/applyOthersRecall/" + id, {}); //撤回用户其他申请接口-肖东
    },
  },
  account: {
    //到账管理相关接口    
    viewDetail: (mode, params) => {
      //App端查看分配明细-陈国贵
      return mode == "1" ?
        getRequest("app/account/viewDetail", params) //到账查看分配明细-陈国贵
        :
        getRequest("app/transact/viewDetail", params); //财务办理查看分配明细-陈国贵
    },
    getListByInvoiceId: (params) => {
      //app根据多个开票申请id查询开票信息-陈国贵
      return postRequest("app/invoice/getListByInvoiceId", params);
    },

    viewAmount: (params) => { //查看累计分配金额、为分配金额接口-陈国贵
      return getRequest("finance/account/viewAmount", params);
    },
    getByMakeId: id => { //查看累计分配金额、为分配金额接口-陈国贵
      return getRequest("app/invoice/getByMakeId/" + id, {});
    },

    returnInvoice: params => { //App端开票到账接口-陈国贵
      return postRequest("app/account/returnInvoice", params);
    },
    returnBorrow: params => { //App端借款到账接口-陈国贵
      return postRequest("app/account/returnBorrow", params);
    },
    returnMargin: params => { //App端保证金退还-陈国贵
      return postRequest("app/account/returnMargin", params);
    },


    delReturn: (mode, params) => { //App端撤销分配-陈国贵

      return mode == "1" ?
        getRequest("app/account/revocation", params) //到账撤销分配-陈国贵
        :
        getRequest("app/transact/revocation", params); //财务办理撤销分配-陈国贵
    },
    getAmountInfo: id => { //App端根据到账id获取到账详情信息-陈国贵
      return getRequest("app/account/getAmountInfo/" + id, {});
    },
  },
  payment: {
    //添加编辑付款申请
    addEditPayment: (mode, params) => {
      if (mode == "add") {
        return postRequest("app/payment/add", params);
      } else {
        return postRequest("app/payment/edit", params);
      }
    },
    //根据id获取付款申请详情
    details: (id) => {
      return getRequest("app/payment/get/" + id, {});
    },
    //删除
    delete: (id) => {
      return getRequest("app/payment/delete/" + id, {});
    },
    //撤回
    reback: (id) => {
      return getRequest("app/payment/recall/" + id, {});
    },
    //重新提交
    resubmission: (id) => {
      return getRequest("app/payment/againSubmit/" + id, {});
    },
  },
  paymentHandOver: {
    //移交申请相关接口
    // 报销移交选择项目列表-陈国贵
    getProjectList: (pageNum, pageSize, param) => {
      return postRequest("app/funding/transfer/projectList/" + pageNum + '/' + pageSize, param);
    },
    //添加编辑付款移交申请-陈国贵
    update: (mode, params) => {

      if (mode == "add") {
        return postRequest("app/funding/transfer/add", params);
      } else {
        return postRequest("app/funding/transfer/edit", params);

      }
    },
    //根据id获取付款移交申请详情 
    details: (id) => {
      return getRequest("app/funding/transfer/get/" + id, {});
    },

    deleteHandOver: (mode, id) => {
      if (mode == "hold") {
        return getRequest("app/funding/transfer/delete/" + id, {});
      } else {
        return getRequest("app/funding/transfer/recall/" + id, {});
      }
    },
    // //删除
    // delete: (id) => {
    //   return getRequest("app/funding/transfer/delete/" + id, {});
    // },
    // //撤回 

    // reback: (id) => {
    //   return getRequest("app/funding/transfer/recall/" + id, {});
    // },
    //重新提交 
    resubmission: (id) => {
      return getRequest("app/funding/transfer/againSubmit/" + id, {});
    },
    //付款移交列表-分页-陈国贵
    transferList: (pageNum, pageSize, param) => {
      return postRequest("app/funding/transfer/fundingList/" + pageNum + '/' + pageSize, param);
    },
  },
  invoice: {
    //开票历史记录
    //获取开票号
    makeInvoicelist: params => {
      return getRequest("app/invoice/makeInvoicelist", params);
    },
    getListByInvoiceId: params => {
      return postRequest("app/invoice/getListByInvoiceId", params);
    },
    disagree: id => { //app不同意开票接口-陈国贵
      return getRequest("app/invoice/disagree/" + id, {});
    },
    makeInvoice: params => { //app 财务开票接口-陈国贵
      return postRequest("app/invoice/make", params);
    },
    getBadInvoice: id => { //根据作废申请id发票作废信息-陈国贵
      return getRequest("app/invalid/getInvoiceInvalid/" + id, {});
    },
    addAbolishInvoice: params => {
      return postRequest("app/invalid/add", params);
    },
  },
  //申请项目开票 / 申请作废开票
  projectOpenTickets: {
    //添加和编辑接口
    addEditApplyOpenTickets: (mode, params) => {
      if (mode == "edit") {
        return postRequest("app/invoice/edit", params);
      } else {
        return postRequest("app/invoice/add", params);
      }
    },
    //获取开票申请
    invoiceDetail: (id) => {
      return getRequest("app/invoice/get/" + id, {});
    },
    //删除开票申请
    deleteApplyOpenTickets: (id) => {
      return getRequest("app/invoice/delete/" + id, {});
    },
    //根据合同code查询合同金额、合同累计开票金额
    getAmountByContractCode: (params) => {
      return getRequest("app/invoice/getAmountByContractCode", params);
    },


    //个人作废开票申请接口

    getByMakeId: id => { //根据开票id获取发票信息-陈国贵
      return getRequest("app/invoice/getByMakeId/" + id, {});
    },
    getBadInvoice: id => { //根据作废申请id发票作废信息-陈国贵
      return getRequest("app/invalid/getInvoiceInvalid/" + id, {});
    },
    //添加和编辑发票作废接口
    addAbolishInvoice: (mode, params) => {
      if (mode == "edit") { //编辑发票作废申请
        return postRequest("app/invalid/edit", params);
      } else { //新增发票作废申请
        return postRequest("app/invalid/add", params);
      }
    },
    delAbolishInvoice: (mode, id) => {
      if (mode == "hold") { //删除发票作废申请
        return getRequest("app/invalid/delete/" + id, {});
      } else { //撤回发票作废申请
        return getRequest("app/invalid/recall/" + id, {});
      }
    },
  },
  //财务办理相关接口
  transact: {
    viewDetail: (params) => {
      //查看办理明细-陈国贵
      return getRequest("/app/transact/viewDetail", params);
    },
    //财务办理相关接口
    deal: (params) => {
      //app端办理接口-陈国贵
      return postRequest("/app/transact/deal", params);
    },
    viewAmount: (params) => {
      //app端查看未办理、累计办理金额-陈国贵
      return getRequest("/app/transact/viewAmount", params);
    },
  }

};

export default finance;